import { useState, useCallback } from 'react';
import { useMutation } from '@grandvisionhq/graphql';
import { VALIDATE_ACCOUNT } from '../operations/mutations/validate-account.js';

const useValidateAccount = ()=>{
    const [isWrongDOB, setIsWrongDOB] = useState(false);
    const onError = useCallback(({ graphQLErrors , networkError  })=>{
        setIsWrongDOB(true);
        return null;
    }, [
        setIsWrongDOB
    ]);
    const [validateAccount, { data , loading , error  }] = useMutation(VALIDATE_ACCOUNT, {
        onError
    });
    const callback = (input)=>{
        setIsWrongDOB(false);
        validateAccount({
            variables: {
                input
            }
        }).catch((e)=>setIsWrongDOB(true)
        );
    };
    if ((data === null || data === void 0 ? void 0 : data.validateCustomerAccount.__typename) === 'AccountValidatedSuccessfully') {
        return [
            callback,
            {
                customerId: data === null || data === void 0 ? void 0 : data.validateCustomerAccount.customerId,
                loading,
                error,
                isWrongDOB
            }, 
        ];
    } else if ((data === null || data === void 0 ? void 0 : data.validateCustomerAccount.__typename) === 'AccountValidationMaxRetriesError') {
        return [
            callback,
            {
                retries: data === null || data === void 0 ? void 0 : data.validateCustomerAccount.retries,
                loading,
                error,
                isWrongDOB
            }, 
        ];
    }
    return [
        callback,
        {
            loading,
            error,
            isWrongDOB
        }
    ];
};

export { useValidateAccount };
//# sourceMappingURL=use-validate-account.js.map
